import PropTypes from 'prop-types';

const BACKUP_POLICY_ITEM_SHAPE = {
  id: PropTypes.string,
  frequencyInterval: PropTypes.number,
  frequencyUnit: PropTypes.string,
  retentionValue: PropTypes.number,
  retentionUnit: PropTypes.oneOf(['DAYS', 'WEEKS', 'MONTHS']),
};

const BACKUP_DELIVERY_TYPE = {
  AUTOMATION_PULL: 'AUTOMATION_PULL',
  DIRECT_ATTACH: 'DIRECT_ATTACH',
  MANUAL_DOWNLOAD: 'MANUAL_DOWNLOAD',
  POINT_IN_TIME: 'POINT_IN_TIME',
};

const BACKUP_DELIVERY_METHOD = {
  AUTOMATION_PULL: 'automated',
  MANUAL_DOWNLOAD: 'download',
  POINT_IN_TIME: 'pointInTime',
};

const TENANT_BACKUP_DELIVERY_TYPE = {
  DOWNLOAD: 'DOWNLOAD',
  RESTORE: 'RESTORE',
};

const TENANT_BACKUP_DELIVERY_METHOD = {
  DOWNLOAD: 'DOWNLOAD',
  RESTORE: 'RESTORE',
};

const RESTORE_STRATEGY_TYPE = {
  SERVERLESS_STREAMING: 'SERVERLESS_STREAMING',
};

export {
  BACKUP_DELIVERY_TYPE,
  BACKUP_DELIVERY_METHOD,
  TENANT_BACKUP_DELIVERY_TYPE,
  TENANT_BACKUP_DELIVERY_METHOD,
  BACKUP_POLICY_ITEM_SHAPE,
  RESTORE_STRATEGY_TYPE,
};
